"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _types = require("../../contexts/types");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AddToOrRemoveFromListContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FavoritesHeart_Dialog_AddToListContent" */'../FavoritesDialogContent/AddToOrRemoveFromListContent')))).AddToOrRemoveFromListContent
}));
const AnonymousContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FavoritesHeart_Dialog_AnonymousContent" */'../FavoritesDialogContent/AnonymousContent')))).AnonymousContent
}));
const CreateOrEditModeContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FavoritesHeart_Dialog_CreateOrEditContent" */'../CreateOrEditContent/CreateOrEditContent')))).CreateOrEditContent
}));
const DeleteModeContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FavoritesHeart_Dialog_DeleteContent" */'../DeleteContent/DeleteContent')))).DeleteContent
}));
const Dialog = ({
  lastUsedListId,
  mode,
  open,
  prefilledProductCodes,
  shouldRedirectOnSuccess,
  onClose
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const content = (0, _react.useMemo)(() => {
    if (isAnonymousUser) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AnonymousContent, {});
    }
    switch (mode) {
      case _types.FavoritesDialogMode.Create:
      case _types.FavoritesDialogMode.Edit:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(CreateOrEditModeContent, {
          isCreateMode: mode === _types.FavoritesDialogMode.Create,
          lastUsedListId: lastUsedListId,
          prefilledProductCodes: prefilledProductCodes,
          shouldRedirectOnSuccess: shouldRedirectOnSuccess,
          onDialogClose: onClose
        });
      case _types.FavoritesDialogMode.Delete:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(DeleteModeContent, {
          lastUsedListId: lastUsedListId,
          shouldRedirectOnSuccess: shouldRedirectOnSuccess,
          onDialogClose: onClose
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(AddToOrRemoveFromListContent, {
          onClose: onClose
        });
    }
  }, [isAnonymousUser, lastUsedListId, mode, onClose, prefilledProductCodes, shouldRedirectOnSuccess]);
  const header = (0, _react.useMemo)(() => {
    if (isAnonymousUser) {
      return translations.anonymousDialogTitle;
    }
    switch (mode) {
      case _types.FavoritesDialogMode.Create:
        return translations.createNewList;
      case _types.FavoritesDialogMode.Delete:
        return translations.deleteList;
      case _types.FavoritesDialogMode.Edit:
        return translations.editList;
      default:
        return translations.addToListDialogTitle;
    }
  }, [isAnonymousUser, mode, translations.addToListDialogTitle, translations.anonymousDialogTitle, translations.createNewList, translations.deleteList, translations.editList]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
    drawer: true,
    "data-testid": getTestId(_constants.FAVORITES_DIALOG),
    open: open,
    header: header,
    size: "small",
    zIndex: theme.zIndex.modal + 2,
    onClose: onClose,
    children: content
  });
};
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map